// The uuid is born when the customer submits the form, so the history entry they are standing on
// (/checkout/create-account or /checkout/shipping) was pushed without one. Stamp it onto that entry
// before pushing the payment page, so browser Back can be recognised as a finished checkout later —
// CompletedGuestCheckoutGuard has only the URL to go on, and the app state after a successful order
// is deliberately identical to "ready to order again" (the cart keeps a pack at qty 1).
export const goToPaymentKeepingUuidInHistory = (navigate, pathname, uuid) => {
    navigate(`${pathname}?uuid=${uuid}`, { replace: true })
    navigate(`/checkout/payment?uuid=${uuid}`)
}
